module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "Praise-Heading"
  }, [_c('span', {
    staticClass: "Bold CharOverride-1"
  }, [_vm._v("Praise for "), _c('br')]), _c('span', {
    staticClass: "Italic CharOverride-2"
  }, [_vm._v("Sustainable Badass")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Quote"
  }, [_vm._v("“Gittemarie is a one-of-a-kind creator and a much-needed voice in the movement. Her attention to detail and level of research is a true testament not only to the quality of her work, but to the intensity with which she takes on the waste crisis. A much-respected and positi"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ve")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("force!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Author"
  }, [_vm._v("—Immy Lucas (@Sustaina"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("bly_Vegan)")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Quote"
  }, [_vm._v("“Gittemarie is creator that not only provides helpful tips on living a zero-waste and vegan lifestyle, but also articulates it in way that is"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("appr"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("oachable.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Author"
  }, [_vm._v("—Jhánneu Roberts "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("(@Jhanneu)")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Quote"
  }, [_vm._v("“Gittemarie provides extensive amounts of accessible eco-friendly tips and education for those entering a sustainability lifestyle. With themed recipes and fun humor, Gittemarie is paving the way for sustainable"), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("futures.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Author"
  }, [_vm._v("—Isaias Hernandez (@QueerB"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("rownVegan)")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Quote"
  }, [_vm._v("“"), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }, [_vm._v("Sustainable Badass ")]), _vm._v("is enlightening and entertaining! It’ll have you reaching for your reusable bags and turning that eco-guilt int"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("o")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("action.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Author"
  }, [_vm._v("—Kathryn Kellogg, author of "), _c('span', {
    staticClass: "Bold-Italic _idGenCharOverride-1"
  }, [_vm._v("101 Ways to Go Zero Waste")]), _c('span', {
    staticClass: "Italic _idGenCharOverride-1"
  }), _vm._v("(@going.z"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ero.waste)")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Quote"
  }, [_vm._v("“Gittemarie has been an inspiration to me for years! She’s always prepared to address a given environmental concern with an educated perspective and provide solutions to her audience. Not to mention her style, which makes her my personal favorite eco-fas"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("hionista.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Author"
  }, [_vm._v("—Shelbi Orme (@sh"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("elbizleee)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c3f1e83","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SustainableBadass.vue
// module id = 60
// module chunks = 0